// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"f0bc11cc","159":"7f22e6d8","453":"11a0c67d","549":"5f3cb20c","556":"270e46c9","639":"34ca10cd","709":"ad6f818b","778":"c1c8081e","781":"79fe09c6","848":"9da37500","878":"676b9f8e"}[chunkId] + ".chunk.js";
};